import {Route} from "react-router-dom";
import {ModulesListPage} from "./ModulesListPage";
import {ModuleEditorPage} from "./ModuleEditorPage";

export function ModuleEditorRoutes() {
    return [
        <Route key="/modules" exact path="/modules">
            <ModulesListPage/>
        </Route>,
        <Route key="/modules/edit" path="/modules/:namespace/:moduleId">
            <ModuleEditorPage/>
        </Route>,
    ];
}
